import { TextInput, SelectInput, DateInput } from './FormComponents';

const companyTypes = [
  { value: 'Private Limited', label: 'Private Limited' },
  { value: 'Public Limited', label: 'Public Limited' },
  { value: 'LLP', label: 'LLP' },
  { value: 'Partnership', label: 'Partnership' },
  { value: 'Sole Proprietorship', label: 'Proprietary' }
];

const natureOfBusiness = [
  // Media section
  { 
    value: "Media", 
    label: "Media", 
    style: { fontWeight: 'bold', color: '#737171' }, 
    disabled: true 
  },
  { 
    value: "Newspapers", 
    label: "Newspapers", 
    space:true 
  },
  { 
    value: "TV Channels", 
    label: "TV Channels", 
    space:true 
  },
  { 
    value: "Radio Stations", 
    label: "Radio Stations", 
    space:true 
  },
  { 
    value: "Magazines", 
    label: "Magazines", 
    space:true 
  },
  { 
    value: "Cinema Screens", 
    label: "Cinema Screens", 
    space:true 
  },
  { 
    value: "OOH Sites", 
    label: "OOH Sites", 
    space:true 
  },
  { 
    value: "Digital Media", 
    label: "Digital Media", 
    space:true 
  },
  
  // Goods section
  { 
    value: "Goods", 
    label: "Goods", 
    style: { fontWeight: 'bold', color: '#737171' }, 
    disabled: true 
  },
  { 
    value: "Electronics", 
    label: "Electronics", 
    space:true 
  },
  { 
    value: "Apparels", 
    label: "Apparels", 
    space:true 
  },
  { 
    value: "Appliances", 
    label: "Appliances", 
    space:true 
  },
  { 
    value: "Furnishing", 
    label: "Furnishing", 
    space:true 
  },
  { 
    value: "Accessories", 
    label: "Accessories", 
    space:true 
  },
  { 
    value: "Interiors", 
    label: "Interiors", 
    space:true 
  },
  { 
    value: "Merchandise", 
    label: "Merchandise", 
    space:true 
  },
  
  // Services section
  { 
    value: "Services", 
    label: "Services", 
    style: { fontWeight: 'bold', color: '#737171' }, 
    disabled: true 
  },
  { 
    value: "Hotel Accommodation", 
    label: "Hotel Accommodation", 
    space:true 
  },
  { 
    value: "Holiday Packages", 
    label: "Holiday Packages", 
    space:true 
  },
  { 
    value: "Banquets / Conferences", 
    label: "Banquets / Conferences", 
    space:true 
  },
  { 
    value: "Health Care & Wellness", 
    label: "Health Care & Wellness", 
    space:true 
  },
  { 
    value: "Restaurants & Clubs", 
    label: "Restaurants & Clubs", 
    space:true 
  },
  { 
    value: "Spas, Salons & Gyms", 
    label: "Spas, Salons & Gyms", 
    space:true 
  },
  { 
    value: "Events & Exhibitions", 
    label: "Events & Exhibitions", 
    space:true 
  },
  { 
    value: "Others", 
    label: "Others", 
    space:true 
  }
];
const squareStyle = {
    borderRadius: '0',
    border: '1px solid #ced4da',
    fontSize:'14px' 
};

const CompanyDetails = ({ formData,errorData, handleChange,handleBlur,requiredField }) => (

  <div>
    <div className="row">
      <div className="col-md-6">
        <TextInput
          label="Name of Company"
          name="companyName"
          value={formData.companyName}
          onChange={handleChange}
          required
          inputClassName="no-border-radius"
          errorData={errorData.companyName}
          id="companyName"
          handleBlur={handleBlur}
        />
      </div>
      <div className="col-md-6">
        <SelectInput
          label="Company Type"
          name="companyType"
          value={formData.companyType}
          onChange={handleChange}
          required
          options={companyTypes}
          id="companyType"
          selectClassName="no-border-radius"
          errorData={errorData.companyType}
        />
      </div>
    </div>

    <div className="row">
      <div className="col-md-6">
        <SelectInput
          label="Nature of Business"
          name="natureOfBusiness"
          value={formData.natureOfBusiness}
          onChange={handleChange}
          required
          options={natureOfBusiness}
          id="natureOfBusiness"
          selectClassName="no-border-radius"
          errorData={errorData.natureOfBusiness}
        />
      </div>
      <div className="col-md-6">
        <DateInput
          label="Date of Establishment"
          name="dateOfEstablishment"
          value={formData.dateOfEstablishment}
          onChange={handleChange}
          required
          id="dateOfEstablishment"
          inputClassName="no-border-radius"
          errorData={errorData.dateOfEstablishment}
        />
      </div>
    </div>

    <div className="row">
      <div className="col-md-6">
       
        <div className="d-flex justify-content-between align-items-center mb-0">
          <label htmlFor="gstin" style={{fontWeight:"bold"}} className="form-label mb-0">
            GSTIN {requiredField.includes('gstin') ? <><span style={{color:'red'}}>*</span></> : ''}
          </label>
          <div className="form-check d-flex align-items-center mb-0">
            <input
              className="form-check-input"
              type="checkbox"
              id="isUnregisteredDealer"
              name="isUnregisteredDealer"
              checked={formData.isUnregisteredDealer}
              disabled={formData.companyType == "Sole Proprietorship" || formData.companyType == "Partnership" ? false : true}
              onChange={handleChange}
              style={squareStyle}                  
            />
            <label
              className="form-check-label mb-0 ms-2"
              htmlFor="isUnregisteredDealer"
              style={{ userSelect: 'none' }}
            >
              Unregistered Dealer
            </label>

          </div>
        </div>

   
          <input
            type="text"
            className="form-control no-border-radius"
            id="gstin"
            name="gstin"
            value={formData.gstin}
            onChange={handleChange}
            readOnly={formData.isUnregisteredDealer}
            required
               style={squareStyle}
               onBlur={handleBlur}
            
          />
<label style={{color:"red"}} htmlFor="">{errorData.gstin}</label>
      </div>

      <div className="col-md-6">
        <TextInput
          label="PAN No"
          name="panNo"
          id="panNo"
          value={formData.panNo}
          onChange={handleChange}
          required
          inputClassName="no-border-radius"
          errorData={errorData.panNo}
          handleBlur={handleBlur}
        />
      </div>
    </div>
  </div>
);

export default CompanyDetails;
